import React from 'react';
import {motion} from 'framer-motion';

import styles from './styles/text-box.module.css';

export default function TextBox({ TextImg, second }) {
    const textMotion = {
        hidden: { 
            opacity: 0,
            x: -46,
            filter: 'brightness(50%)', // 'brightness(50%) contrast(50%)'
            // clipPath: 'inset(0 50% 0 0)'
        },
        visible: { 
            opacity: 1,
            x: 0,
            filter: 'brightness(100%)', // 'brightness(100%) contrast(100%)'
            // clipPath: 'inset(0 0% 0 0)',
            transition: {
                ease: 'easeIn', 
                opacity: {
                    ease: 'easeIn',
                    duration: 0.4
                },
                duration: 0.4,
                delay: second ? 0.6 : 0
            }
        }
    };
    
    const maskMotion = {
        hidden: { 
            opacity: 0,
            x: 0
        },
        visible: { 
            opacity: [0, 1, 0],
            x: -46,
            transition: {
                ease: 'easeIn',
                times: [0, 0.5, 1],
                duration: 0.4,
                delay: second ? 0.6 : 0
            }
        }
    };

    return (
        <div className={styles.wrapper}>
            <motion.div
                className={styles.boxText}
                initial='hidden'
                animate='visible'
                variants={textMotion}
            >
                <TextImg />
            </motion.div>
            <motion.div
                className={styles.mask}
                initial='hidden'
                animate='visible'
                variants={maskMotion}
            />
            
        </div>
    );
}
